export const PrimaryHeaderUat = {
  backButton: 'layout.backButton',
}
